export default __webpack_public_path__ + "static/media/66711A.0d558da9.png";